export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, user-scalable=no"},{"hid":"description","name":"description","content":"Award-winning stainless steel wood-burning fire pits, camp stoves, Pi Pizza Oven, grill, and accessories"},{"http-equiv":"Accept-CH","content":"DPR, Viewport-Width, Width, Downlink"},{"http-equiv":"Accept-CH-Lifetime","content":"86400"},{"name":"application-name","content":"Solo Stove"},{"name":"theme-color","content":"#1a1a1a"},{"name":"format-detection","content":"telephone=no"},{"name":"og:type","content":"website"},{"hid":"og:title","name":"og:title","content":"Solo Stove - Fire Pits, Pi Pizza Oven, Grills, Camp Stoves, and More!"},{"hid":"og:description","name":"og:description","content":"Award-winning stainless steel wood-burning fire pits, camp stoves, Pi Pizza Oven, grill, and accessories"},{"hid":"og:image","name":"og:image","content":"https://cdn11.bigcommerce.com/s-b5b4c/images/stencil/986x986/products/62/3055/bon-sd-1-1000__09495.1642528899.jpg?c=2"},{"name":"version-num","content":"1.2.4"},{"name":"google-site-verification","content":"iO4khMRHm-wQQh8ByKZ7ZmwEG_2PbgZR59hUzEpZae0"}],"link":[{"rel":"preload","as":"script","href":"https://app.termly.io/resource-blocker/9217d057-be59-4dc3-928c-f28cd982c763?autoBlock=on"},{"rel":"preload","as":"style","href":"https://cdn.fonts.net"},{"rel":"preconnect","href":"https://cdn.fonts.net"},{"rel":"preconnect","href":"https://content.solostove.com"},{"rel":"preconnect","href":"https://app.termly.io"},{"rel":"preconnect","href":"https://cdn.dynamicyield.com"},{"rel":"preconnect","href":"https://staticw2.yotpo.com"},{"rel":"preconnect","href":"https://www.paypal.com"},{"rel":"stylesheet","href":"https://cdn.fonts.net"},{"rel":"stylesheet","href":"https://cdn.fonts.net/kit/c1eca4f9-5d07-4c11-82ab-d9ddc236d267/c1eca4f9-5d07-4c11-82ab-d9ddc236d267.css"},{"hid":"canonical","rel":"canonical","href":"https://stg.solostove.com"},{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"icon","type":"image/png","href":"/icon.png"}],"style":[],"script":[{"type":"text/javascript","data-termly-config":true,"innerHTML":"window.TERMLY_CUSTOM_BLOCKING_MAP = {\n            \"www.googletagmanager.com\": \"essential\",\n            \"content.solostove.com\": \"essential\",\n            \"www.paypal.com\": \"essential\",\n            \"staticw2.yotpo.com\": \"performance\",\n          }"},{"type":"text/javascript","src":"https://app.termly.io/resource-blocker/9217d057-be59-4dc3-928c-f28cd982c763?autoBlock=on"},{"type":"text/javascript","src":"https://www.paypal.com/sdk/js?client-id=ASPnzGKv_posw1tvk4ge2w76G0v_rQfPv9GFTgdfa0Y5Rsuwu-ycnYHULsbr74y40pctoGFAqU3NN7SN&components=messages,buttons","async":true}],"noscript":[],"title":"Solo Stove - Fire Pits, Pi Pizza Oven, Grills, Camp Stoves, and More! | Solo Stove","htmlAttrs":{"lang":"en"},"__dangerouslyDisableSanitizersByTagID":{"ga4-gtag":["innerHTML"]}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false